import {WarehouseLogin} from 'constants/WarehouseConstants';
import {RESTWarehouseParameter} from 'insights/parameters/RESTParameterTypes';
import * as net from 'util/Net';

interface WarehouseLogins {
  logins: Array<WarehouseLogin>;
}

export interface CreateUserDefinedViewRequest {
  view_name: string;
  view_query: string;
  view_description: string;
  origin_analytics_query_api_identifier: string;
  parameters?: Array<RESTWarehouseParameter>;
}

export interface CreateUserDefinedViewResponse {}

export function fetchLogins(): Promise<WarehouseLogins> {
  return Promise.resolve(net.getJSON('/1/api/warehouse/logins'));
}

export function createLogin(label: string): Promise<WarehouseLogin> {
  return Promise.resolve(
    net.postJSON({
      url: '/1/api/warehouse/logins',
      data: {label},
    })
  );
}

export function revokeLogin(login: WarehouseLogin): Promise<WarehouseLogin> {
  return Promise.resolve(net.delete_({url: `/1/api/warehouse/logins/${login.id}`}));
}

export function createUserDefinedView(
  data: CreateUserDefinedViewRequest
): Promise<CreateUserDefinedViewResponse> {
  return net.postJSONPromise({
    url: '/1/api/warehouse/user-defined-views',
    data,
  });
}

export function deleteUserDefinedView(viewId: string): Promise<void> {
  return net.deletePromise({
    url: `/1/api/warehouse/user-defined-views/${viewId}`,
  });
}

export function refreshUserDefinedView(viewId: string): Promise<void> {
  return net.postJSONPromise({
    url: `/1/api/warehouse/user-defined-views/${viewId}/refresh-warehouse-existence-status`,
    data: {},
  });
}
